export const SET_VALUE = 'SET_VALUE';

interface FormReducerState {
  [formId: string]: {
    [fieldId: string]: any;
  };
}

export const formReducerInitialState: FormReducerState = {};

export const formReducer = (state: FormReducerState, action: any): FormReducerState => {
  switch (action.type) {
    case SET_VALUE: {
      const { formId, fieldId, value } = action.payload;
      return {
        ...state,
        [formId]: {
          ...(state[formId] || {}),
          [fieldId]: value,
        },
      };
    }
    default:
      return state;
  }
};
